import React, { createContext, useContext } from 'react';

const ThemeContext = createContext();

export const useThemeMode = () => {
  const context = useContext(ThemeContext);
  if (!context) {
    throw new Error('useThemeMode must be used within a ThemeModeProvider');
  }
  return context;
};

export const ThemeModeProvider = ({ children }) => {
  // Mode sombre uniquement
  const isDark = true;

  return (
    <ThemeContext.Provider value={{ isDark }}>
      {children}
    </ThemeContext.Provider>
  );
};

// Couleurs du thème sombre moderne avec dégradés profonds
export const darkModeColors = {
  // Backgrounds principaux
  bgPrimary: '#0a0d14',
  bgSecondary: '#0f1419',
  bgCard: 'linear-gradient(165deg, rgba(15, 23, 32, 0.9) 0%, rgba(20, 30, 42, 0.85) 50%, rgba(12, 20, 30, 0.9) 100%)',
  bgSidebar: 'linear-gradient(180deg, rgba(10, 15, 22, 0.98) 0%, rgba(15, 22, 32, 0.95) 50%, rgba(10, 15, 22, 0.98) 100%)',
  bgInput: 'rgba(15, 22, 32, 0.8)',
  
  // Text
  textPrimary: '#ffffff',
  textSecondary: '#94a3b8',
  textMuted: '#64748b',
  
  // Borders
  borderColor: 'rgba(34, 197, 94, 0.12)',
  borderHover: 'rgba(34, 197, 94, 0.25)',
  
  // Shadows
  cardShadow: '0 4px 24px rgba(0, 0, 0, 0.4), 0 0 40px rgba(34, 197, 94, 0.03)',
  cardShadowHover: '0 8px 40px rgba(0, 0, 0, 0.5), 0 0 60px rgba(34, 197, 94, 0.06)',
  
  // Accents - Vert émeraude
  accentPrimary: '#4ade80',
  accentSecondary: '#22c55e',
  accentTertiary: '#10b981',
  accentBg: 'rgba(34, 197, 94, 0.1)',
  accentBgHover: 'rgba(34, 197, 94, 0.15)',
  
  // Gradients pour les accents
  accentGradient: 'linear-gradient(135deg, #4ade80 0%, #22c55e 50%, #10b981 100%)',
  accentGradientSubtle: 'linear-gradient(135deg, rgba(74, 222, 128, 0.2) 0%, rgba(34, 197, 94, 0.1) 100%)',
  
  // Sidebar specific
  sidebarActiveBg: 'linear-gradient(135deg, rgba(34, 197, 94, 0.15) 0%, rgba(16, 185, 129, 0.08) 100%)',
  sidebarActiveColor: '#4ade80',
  sidebarInactiveColor: 'rgba(255, 255, 255, 0.65)',
  sidebarIconBg: 'rgba(34, 197, 94, 0.1)',
  sidebarIconColor: 'rgba(255, 255, 255, 0.5)',
};

// Export pour compatibilité
export const lightModeColors = darkModeColors;

export default ThemeContext;
